import { VehicleBooking } from "features/CenterContent/VehicleDetails/ReserveAlternativeTransportDetails/VehicleBooking";
import AddVehicle from "features/VehicleSidebar/VehicleList/AddVehicles/AddVehicle";
import { VehicleSummary } from "features/CenterContent/VehicleDetails/shared/VehicleSummary";
import { vehicleTypeToIcon } from "features/CenterContent/VehicleDetails/shared/utils";
import { EditOutline30Icon } from "@vygruppen/spor-icon-react";
import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, HStack, Text } from "shared/components/Spor";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";
import styled from "styled-components";

type Props = {
  reserveAlternativeTransport: ReserveAlternativeTransport;
};

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 1;
`;

export const ReserveVehicleInfo: FC<Props> = ({
  reserveAlternativeTransport,
}) => {
  const location = useLocation();
  const [showEditModal, setShowEditModal] = useState(false);

  const {
    baseStopName,
    workShiftId,
    shiftStartTime,
    operatorName,
    shiftEndTime,
    type,
    driverPhoneNumber,
    serviceType,
  } = reserveAlternativeTransport;
  // Prefix unused variables with underscore to mark them intentionally unused for the linter
  const [_Icon, _iconTitle] = vehicleTypeToIcon.get(type)!;

  const { vehicleTitle } = location.state || { vehicleTitle: "Reserve" };

  return (
    <InfoWrapper>
      <VehicleSummary
        vehicleInfo={operatorName}
        title={vehicleTitle}
        type={type}
        subTitle={workShiftId}
        route={baseStopName}
        startTime={shiftStartTime}
        endTime={shiftEndTime}
        vehicleStatus={null}
        logs={[]}
        driverPhoneNumber={driverPhoneNumber}
      />

      <HStack role="group" mt="12px">
        <Button
          variant="tertiary"
          size="xs"
          onClick={() => setShowEditModal(true)}
          leftIcon={<EditOutline30Icon />}
        >
          <Text>Rediger</Text>
        </Button>
        <VehicleBooking vehicle={reserveAlternativeTransport} />
      </HStack>
      {showEditModal && (
        <AddVehicle
          editVehicle={reserveAlternativeTransport}
          isReserveBusTabSelected={(serviceType ?? "RESERVE") === "RESERVE"}
          closeModal={() => setShowEditModal(false)}
        />
      )}
    </InfoWrapper>
  );
};
